export const LISTE_PLAN_MEDIA = {
  title: 'Liste des plans média',
  breadcrumb: {
    home: 'Accueil',
    liste: 'Liste des plans média',
  },
  actions: {
    add: 'Nouveau plan média',
    search: 'Rechercher',
    filtre: 'Filtre',
  },
  tab: {
    code: 'Code',
    gestionnaire: 'Commercial',
    annonceur: 'Annonceur',
    statut: 'Statut',
    datePM: 'Date plan média',
    dateSignature: 'Date signature',
    dateDebut: 'Date début',
    dateFin: 'Date fin',
  },
  filtre: {
    code: 'Code',
    statut: 'Statuts',
    produits: 'Produits',
    commercial: 'Commercial',
  },
};

export const ADD_PLAN_MEDIA = {
  title: {
    ajout: 'Création d\'un plan média',
    edit: 'Modification du plan média',
  },
  breadcrumb: {
    add: 'Création plan média',
    edit: 'Modification plan média',
    racine: 'Accueil',
    liste: 'Liste des plans média',
  },
  actions: {
    cancel: 'Annuler',
  },
  tab: {
    information: 'Plan média',
    evenement: 'Etat d\'avancement',
    commande: 'Ventes',
    commissions: 'Commissions',
  },
  validation: {
    sumCommissions: 'La répartition des commissions doit être de 100%',
    multiCustomer: 'Le client est déjà là',
    leastOneAdvertiser: 'Vous devez indiquer au moins un annonceur par plan média.',
    leastOnePayer: 'Vous devez indiquer au minimum un payeur par plan média.',
    prospectNotAllowed: 'Impossible d\'enregistrer un plan média avec un intervenant prospect',
    notSameDivisionType: 'Les quotes-parts des payeurs doivent être du même type.',
    accountingRecipientOnlyAllowedOnABill: 'Un destinataire comptable n\'a de sens que pour une facture',
    pourcentageDivision: 'La répartition des payeurs n\'est pas de 100%.',
  },
  information: {
    title: 'Informations générales',
    code: 'Code',
    gestionnaire: 'Commercial',
    statut: 'Statut',
    agence: 'Agence',
    datePM: 'Date plan média',
    dateSignature: 'Date de signature',
    dateDebut: 'Date début',
    dateFin: 'Date fin',
  },
  commissions: {
    actions: {
      add: 'Ajouter une commission',
      dupliquer: 'Dupliquer',
      supprimer: 'Supprimer',
    },
    tab: {
      commercial: 'Commercial',
      pourcentage: 'Pourcentage',
    },
  },
  intervenant: {
    title: 'Intervenants',
  },
  piecesJointes: {
    title: 'Pièces jointes',
  },
  notifications: {
    successCreation: 'Création du plan média réalisée avec succès.',
    successChange: 'Modification du plan média réalisée avec succès.',
  },
  statutType: {
    saisi: 'Saisi',
    envoye: 'Envoyé',
    accepte: 'Accepté',
    acceptePartiellement: 'Accepté partiellement',
    refuse: 'Refusé',
  },
  evenement: {
    titleEdit: 'Modifier un événement',
    titleAdd: 'Ajouter un événement',
    actions: {
      add: 'Ajouter un événement',
      remove: 'Supprimer',
    },
    information: {
      dateEvenement: 'Date événement',
      gestionnaire: 'Commercial',
      type: 'Type événement',
      descriptif: 'Descriptif',
      ventes: 'Vente',
    },
    error: {
      dateEvenement: 'Date événement de la liste d\'événement',
      gestionnaire: 'Commercial de la liste d\'événement',
      type: 'Type événement de la liste d\'événement',
    },
  },
  commande: {
    actions: {
      add: 'Ajouter commande',
      addDevis: 'Nouveau devis',
      addCommande: 'Nouvelle commande',
      remove: 'Supprimer',
    },
    information: {
      code: 'Code',
      status: 'Etat',
      type: 'Type',
      date: 'Date',
      customers: 'Clients',
      amountHt: 'Montant HT',
      commercial: 'Commercial(e)',
      folderCode: 'Code dossier',
      datePremierAffichage: 'Date de campagne',
      categorieVente: 'Type de produit',
      etatRenouvellement: 'Renouvellement',
      estSigne: 'Signée',
      devis: 'Devis',
      commande: 'Commande',
    },
    filtre: {
      produits: 'Produits',
      typeProduit: 'Type de produit',
      datePremierAffichage: 'Date de campagne',
      au: 'au',
      client: 'Clients',
      etat: 'Liste des états',
      commercial: 'Commercial',
      referenceClient: 'Référence client',
      agence: 'Agence',
      codeDossier: 'Code dossier',
      theme: 'Thème',
      assistant: 'Assistant',
      noAssistant: 'Sans assistant',
      noCommercial: 'Sans commercial',
      estSigne: 'Signé',
      interne: 'Commande interne',
    },
  },
};

export const DETAIL_PLAN_MEDIA = {
  title: 'Détail plan média: {code}',
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste des plans média',
    detail: 'Détail plan média: {code}',
  },
  montant: {
    title: 'Récapitulatif budgétaire du plan média',
    montantTtc: 'Montant TTC : {montant}€',
    montantHt: 'Montant HT : {montant}€',
    montantTva: 'Montant TVA : {montant}€',
    montantFacture: 'Montant facturé : {montant}€',
    montantResteAFacturer: 'Reste à facturer : {montant}€',
    montantAcompte: 'Acomptes : {montant}€',
    montantRegle: 'Montant réglé : {montant}€',
  },
  tab: {
    information: 'Plan média',
    evenement: 'Etat d\'avancement',
    commande: 'Ventes',
    commissions: 'Commissions',
  },
  information: {
    title: 'Informations générales',
    code: 'Code',
    gestionnaire: 'Commercial',
    statut: 'Statut',
    datePM: 'Date plan média',
    dateSignature: 'Date de signature',
    dateDebut: 'Date début',
    dateFin: 'Date fin',
  },
};
